<template>
  <div>
    <kst-output print-mode field="ReceiveNumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="PurchasingDate" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="PurchasingNumber" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "./ReceivePrintDetailsCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>